class Dropdown extends HTMLElement {
  constructor() {
    super();
    this.classList.add('dropdown');
    this.trigger = this.querySelector('.dropdown-btn');
    this.content = this.querySelector('.dropdown-content');
    this.dropdownItems = this.content.querySelectorAll('a');
    this.init();
  }

  init() {
    this.trigger.addEventListener('click', () => {
      const isOpen = this.content.classList.contains('active');
      this.content.classList.toggle('active', !isOpen);
      this.trigger.classList.toggle('active', !isOpen);
      this.trigger.setAttribute('aria-expanded', !isOpen);
      this.content.setAttribute('aria-hidden', isOpen);
    });

    this.trigger.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        const isOpen = this.content.classList.contains('active');
        this.content.classList.toggle('focus-active', !isOpen);
        this.trigger.click();
        if (!isOpen) {
          this.dropdownItems[0].focus();
        }
      }
    });

    this.content.addEventListener('keydown', (event) => {
      const currentIndex = Array.from(this.dropdownItems).indexOf(
        document.activeElement,
      );
      let nextIndex = -1;

      if (event.key === 'ArrowDown') {
        nextIndex = (currentIndex + 1) % this.dropdownItems.length;
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        nextIndex =
          (currentIndex - 1 + this.dropdownItems.length) %
          this.dropdownItems.length;
        event.preventDefault();
      } else if (event.key === 'Escape') {
        this.trigger.click();
        this.trigger.focus();
        event.preventDefault();
      }

      if (nextIndex !== -1) {
        this.dropdownItems[nextIndex].focus();
      }
    });

    this.addEventListener(
      'blur',
      (event) => {
        if (!this.contains(event.relatedTarget)) {
          this.content.classList.remove('active');
          this.trigger.classList.remove('active');
          this.trigger.setAttribute('aria-expanded', 'false');
          this.content.setAttribute('aria-hidden', 'true');
        }
      },
      true,
    );

    window.addEventListener('load', () => {
      const activeURL = window.location.href;
      if (activeURL.includes('?sort_by=')) {
        const plpGridSection = document.querySelector(
          '[data-section="product-grid"]',
        );
        if (plpGridSection) {
          plpGridSection.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });
  }
}

if (!customElements.get('drop-down')) {
  customElements.define('drop-down', Dropdown);
}
